import "./style.css";

import React, { useState } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import brandimg from "../../Assets/brandimg.png";
import brandimg2 from "../../Assets/brandimg2.png";
import brandimg3 from "../../Assets/brandimg3.png";
import brandimg4 from "../../Assets/brandimg4.png";
import brandimg5 from "../../Assets/brandimg5.png";
import closeicon from "../../Assets/closeicon.svg";
import crossicon from "../../Assets/menucrossicon.svg";
import emailicon from "../../Assets/emailicon.svg";
import fbicon from "../../Assets/fbicon.svg";
import footerlogo from "../../Assets/footerlogo.png";
import hamburgericon from "../../Assets/hamburgericon.svg";
import instaicon from "../../Assets/instaicon.svg";
import linkedinicon from "../../Assets/linkedinicon.svg";
import locationicon from "../../Assets/locationicon.svg";
import logo from "../../Assets/logo.svg";
import mobileimg from "../../Assets/mobileimg.png";
import mobilelogo from "../../Assets/mobilelogo.svg";
import sec2img from "../../Assets/sec2img.png";
import sec3cardimg1 from "../../Assets/sec3cardimg1.png";
import sec3cardimg2 from "../../Assets/sec3cardimg2.png";
import sec3cardimg3 from "../../Assets/sec3cardimg3.png";
import sec3cardimg4 from "../../Assets/sec3cardimg4.png";
import sec3mobileimg from "../../Assets/sec3mobileimg.png";
import sec4contentimg1 from "../../Assets/sec4contentimg1.png";
import sec4contentimg2 from "../../Assets/sec4contentimg2.png";
import sec4contentimg3 from "../../Assets/sec4contentimg3.png";
import sec7cardimg1 from "../../Assets/sec7cardimg1.png";
import sec7img from "../../Assets/sec7bgimg.png";
import sec8img1 from "../../Assets/sec8img1.png";
import sec8img2 from "../../Assets/sec8img2.png";
import sec8img3 from "../../Assets/sec8img3.png";
import sec8img4 from "../../Assets/sec8img4.png";
import sec8line from "../../Assets/sec8line.png";
import sec9img from "../../Assets/sec9img.png";
import twittericon from "../../Assets/twittericon.svg";
import videoicon from "../../Assets/videoicon.png";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "26.3vw",
  height: "26.4vw",
  bgcolor: "background.paper",
  borderRadius: "0.5vw",
  boxShadow: 24,
};

function LandingPage() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [state, setState] = React.useState({
    top: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    ></Box>
  );
  const Header = () => {
    return (
      <div className="header-parent">
        <div className="header-mobile-con">
          <div className="header-mobile">
            {["top"].map((anchor) => (
              <React.Fragment key={anchor}>
                <div className="mobile-header-con">
                  <div className="mobile-header-sec1">
                    <div className="mobile-header-sec-logo">
                      <img src={mobilelogo} />
                    </div>
                    <div className="mobile-header-ham-btn-con">
                      <button
                        className="mobile-header-ham-btn"
                        onClick={toggleDrawer(anchor, true)}
                      >
                        <span>
                          <img src={hamburgericon} />
                        </span>
                      </button>
                    </div>
                  </div>
                  <div className="mobile-header-sec2-con">
                    <div className="mobile-header-sec2"></div>
                  </div>
                </div>
                <Drawer
                  anchor={anchor}
                  open={state[anchor]}
                  onClose={toggleDrawer(anchor, false)}
                >
                  <div className="header-mobile-sec-con">
                    <div className="header-mobile-sec1">
                      <div className="mobile-header-con">
                        <div className="mobile-header-sec1">
                          <div className="mobile-header-sec-logo">
                            <img src={logo} />
                          </div>
                          <div className="mobile-header-ham-btn-con">
                            <button
                              className="mobile-header-ham-btn"
                              onClick={toggleDrawer(anchor, false)}
                            >
                              <span>
                                <img src={crossicon} />
                              </span>
                            </button>
                          </div>
                        </div>
                        <div className="mobile-header-sec2-con">
                          <div className="mobile-header-sec2"></div>
                        </div>
                      </div>
                    </div>
                    <div className="mobile-menu-con">
                      <div className="mobile-menu">
                        <li>Como Funciona</li>
                        <li>Empresas</li>
                        <li>Ganhe mais dinheiro</li>
                        <li>Instituto Campeão</li>
                        <button>Painel do Usuário</button>
                      </div>
                    </div>
                  </div>
                </Drawer>
              </React.Fragment>
            ))}
          </div>
        </div>
        <div className="header-con">
          <div className="header-sec1">
            <img src={logo} />
          </div>
          <div className="header-sec2">
            <li>
              <a href="#">Como Funciona</a>
            </li>
            <li>
              <a href="#">Empresas</a>
            </li>
            <li>
              <a href="#">Ganhe mais dinheiro</a>
            </li>
            <li>
              <a href="#">Instituto Campeão</a>
            </li>
            <button>Painel do Usuário</button>
          </div>
        </div>
      </div>
    );
  };
  const Sec1Content = () => {
    return (
      <div className="sec1content-con">
        <div className="sec1content">
          <div className="sec1content-sec1">
            <img src={mobileimg} />
          </div>
          <div className="sec1content-sec2">
            <div className="sec1content-sec2-heading-con">
              <h1 className="first-heading">DINHEIRO DE VOLTA</h1>
              <h1 className="second-heading">DEVERDADE!</h1>
            </div>
            <div className="sec1content-sec2-text">
              <p>
                Cadastre-se e comece a receber dinheiro de volta em suas
                compras!{" "}
                <span className="sec1content-sec2-text-span">
                  fácil, rápido e seguro!
                </span>
              </p>
            </div>
            <div className="sec1content-btns">
              <input type="text" placeholder="Seu nome" />
              <input type="number" placeholder="DDD + Telefone" />
            </div>
            <div className="sec1content-btn1">
              <button>Quero começar a receber dinheiro de volta!</button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const Sec2Content = () => {
    return (
      <div className="sec2content-con">
        <div className="sec2content-sec1">
          <div className="sec2content-sec1-heading">
            <h1>Nosso Manifesto</h1>
          </div>
          <div className="sec2content-sec1-heading2">
            <h3>Cashback, NÃO! Dinheiro de volta, SIM!</h3>
          </div>
          <div className="sec2content-sec1-text">
            <p>
              Muitas empresas no Brasil utilizam em suas comunicações palavras e
              termos na língua inglesa. É um velho hábito, em alguns casos até
              cultural dentro das organizações a "americanização" e/ou
              "inglelização". Porém, 95% da população brasileira não fala inglês
              e adotar uma comunicação nesse sentido em certo ponto "exclui" a
              maioria esmagadora das pessoas em nosso país.
              <br />
              <br />
              Nascemos no Brasil e{" "}
              <span className="sec2content-sec1-text-span">
                nossas raízes são brasileiras
              </span>
              , onde em nosso país a língua nativa é o português. Somos uma
              empresa feita por brasileiros para brasileiros. Abolimos da nossa
              comunicação os termos e as palavras em inglês.{" "}
              <span className="sec2content-sec1-text-span">
                {" "}
                Por isso, cashback NÃO! Dinheiro de volta, SIM!
              </span>
              <br />
              <br />
              Assim se estabelece a{" "}
              <span className="sec2content-sec1-text-span">
                {" "}
                Dinheiro campeão
              </span>
              , com amor e respeito a nossa cultura e ao povo.
            </p>
          </div>
          <div className="sec2content-sec1-btn">
            <button onClick={handleOpen}>
              Sim! Quero receber dinheiro de volta!
            </button>
          </div>
        </div>
        <div className="sec2content-sec2">
          <img src={sec2img} />
        </div>
      </div>
    );
  };
  const Sec3Content = () => {
    return (
      <div className="sec3content-secs-parent">
        <div className="sec3content-secs-con">
          <div className="sec3content-parent">
            <div className="sec3content-con">
              <div className="sec3content">
                <div className="sec3content-sec1">
                  <div className="sec3content-sec-cards-con">
                    <div className="sec3-content-cards-sec1-con">
                      <div className="sec3content-sec-card">
                        <img src={sec3cardimg1} />
                        <h1>EFETUE SEU CADASTRO</h1>
                        <p>Lorem ipsum</p>
                      </div>
                      <div className="sec3content-sec-card">
                        <img src={sec3cardimg2} />
                        <h1 style={{ textAlign: "center" }}>
                          ESCOLHA A<br /> LOJA PARCEIRA
                        </h1>
                        <p>Lorem ipsum</p>
                      </div>
                    </div>
                    <div className="sec3-content-cards-sec2-con">
                      <div className="sec3content-sec-card">
                        <img src={sec3cardimg3} />
                        <h1>EFETUE SEU CADASTRO</h1>
                        <p>Lorem ipsum</p>
                      </div>
                      <div className="sec3content-sec-card">
                        <img src={sec3cardimg4} />
                        <h1 style={{ textAlign: "center" }}>
                          RECEBA SEU <br />
                          DINHEIRO DE VOLTA
                        </h1>
                        <p>Lorem ipsum</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="sec3content-sec2-video-con">
              <div className="sec3content-sec2-video">
                <img src={videoicon} />
              </div>
              <div className="video-btn">
                <button onClick={handleOpen}>
                  Quero receber dinheiro de volta!
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="sec3-content-mobile-con">
          <div className="sec3-content-mobile">
            <div className="sec3-content-mobile-sec1-con">
              <div className="sec3-content-mobile-sec1-img">
                <img src={sec3mobileimg} />
              </div>
              <div className="sec3-content-mobile-sec1-text-con">
                <div className="sec3-content-mobile-sec1-text-parent">
                  <div className="sec3-content-mobile-sec1-text">
                    <h3>EFETUE SEU CADASTRO</h3>
                    <p>Lorem ipsum</p>
                  </div>
                </div>
                <div className="sec3-content-mobile-sec1-text-parent">
                  <div className="sec3-content-mobile-sec1-text">
                    <h3>ESCOLHA A LOJA PARCEIRA</h3>
                    <p>Lorem ipsum</p>
                  </div>
                </div>
                <div className="sec3-content-mobile-sec1-text-parent">
                  <div className="sec3-content-mobile-sec1-text">
                    <h3>EFETUE SUA COMPRA</h3>
                    <p>Lorem ipsum</p>
                  </div>
                </div>
                <div className="sec3-content-mobile-sec1-text-parent">
                  <div className="sec3-content-mobile-sec1-text">
                    <h3>RECEBA SEU DINHEIRO DE VOLTA</h3>
                    <p>Lorem ipsum</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="sec3content-sec2-video-con-mobile">
              <div className="sec3content-sec2-video-con">
                <div className="sec3content-sec2-video">
                  <img src={videoicon} />
                </div>
                <div className="video-btn">
                  <button onClick={handleOpen}>
                    Quero receber dinheiro de volta!
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const Sec4Content = (props) => {
    return (
      <div className="sec4content-parent">
        <div className="sec4content-con">
          <div
            style={{
              display: props.sec4contentalignment1,
              alignItems: props.sec4contentalignment2,
              justifyContent: props.sec4contentalignment3,
              flexDirection: props.sec4contentalignment4,
            }}
            className="sec4content"
          >
            <div
              style={{
                display: props.sec4contentsec1alignment1,
                alignItems: props.sec4contentsec1alignment2,
                flexDirection: props.sec4contentsec1alignment3,
              }}
              className="sec4content-sec1"
            >
              <div
                style={{ textAlign: props.sec4contentaligment5 }}
                className="sec4content-sec1-headings"
              >
                <h3>{props.firstheading}</h3>
                <h1>{props.secondheading}</h1>
              </div>
              <div className="sec4content-text">
                <p>{props.text}</p>
              </div>
              <div className="sec4content-btn">
                <button onClick={handleOpen}>{props.btntext}</button>
              </div>
            </div>
            <div className="sec4content-sec2">
              <img src={props.img} />
            </div>
          </div>
        </div>
        <div className="sec4-content-con-mobile">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
            className="sec4content"
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
              className="sec4content-sec1"
            >
              <div
                style={{ textAlign: "start" }}
                className="sec4content-sec1-headings"
              >
                <h3>{props.firstheading}</h3>
                <h1>{props.secondheading}</h1>
              </div>
              <div className="sec4content-sec2">
                <img src={props.img} />
              </div>
              <div className="sec4content-text">
                <p>{props.text}</p>
              </div>
              <div className="sec4content-btn">
                <button onClick={handleOpen}>{props.btntext}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const Sec5Content = () => {
    return (
      <div className="sec5content-con">
        <div className="sec5content">
          <div className="sec5content-header">
            <h1>
              Descubra uma loja campeã{" "}
              <span style={{ color: "#FFD600" }}>perto de você!</span>
            </h1>
          </div>
          <div className="sec5content-btns-con">
            <div className="sec5content-btns">
              <input
                className="sec5content-input"
                placeholder="Digite seu CEP ou Cidade"
              />
              <button className="sec5content-btn2">Buscar lojas</button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const Sec6Content = () => {
    return (
      <div className="sec6content-con">
        <div className="sec6content">
          <div className="sec6content-heading">
            <h1>Confira algumas das nossas lojas parceiras</h1>
          </div>
          <div className="sec6content-cards-con">
            <div className="sec6content-card">
              <div className="sec6content-card-sec1">
                <img src={brandimg} />
                <h1>Lojas Americanas</h1>
                <p>Loja de Departamento</p>
              </div>
              <div className="sec6content-card-sec2"></div>
              <div className="sec6content-card-sec3">
                <p>Receba até</p>
                <h1>15%</h1>
                <p>de volta em suas compras</p>
              </div>
            </div>
            <div className="sec6content-card">
              <div className="sec6content-card-sec1">
                <img src={brandimg2} />
                <h1>Zattini</h1>
                <p>Vestiário</p>
              </div>
              <div className="sec6content-card-sec2"></div>
              <div className="sec6content-card-sec3">
                <p>Receba até</p>
                <h1>15%</h1>
                <p>de volta em suas compras</p>
              </div>
            </div>
            <div className="sec6content-card">
              <div className="sec6content-card-sec1">
                <img src={brandimg3} />
                <h1>Dell</h1>
                <p>Informática</p>
              </div>
              <div className="sec6content-card-sec2"></div>
              <div className="sec6content-card-sec3">
                <p>Receba até</p>
                <h1>15%</h1>
                <p>de volta em suas compras</p>
              </div>
            </div>
            <div className="sec6content-card">
              <div className="sec6content-card-sec1">
                <img src={brandimg4} />
                <h1>Wolksvagem</h1>
                <p>Carros</p>
              </div>
              <div className="sec6content-card-sec2"></div>
              <div className="sec6content-card-sec3">
                <p>Receba até</p>
                <h1>15%</h1>
                <p>de volta em suas compras</p>
              </div>
            </div>
            <div className="sec6content-card">
              <div className="sec6content-card-sec1">
                <img src={brandimg5} />
                <h1>Mc Donalds</h1>
                <p>Alimentação</p>
              </div>
              <div className="sec6content-card-sec2"></div>
              <div className="sec6content-card-sec3">
                <p>Receba até</p>
                <h1>15%</h1>
                <p>de volta em suas compras</p>
              </div>
            </div>
          </div>
          <div className="sec6content-btn">
            <button>Quero ver todas as lojas</button>
          </div>
        </div>
      </div>
    );
  };
  const Sec7Content = () => {
    return (
      <div className="sec7content-con">
        <div className="sec7content">
          <div className="sec7content-sec2-con">
            <div className="sec7content-sec2">
              <div className="sec7content-sec-heading">
                <h1>
                  <span style={{ fontSize: "2.6vw", color: "#421072" }}>
                    QUEM USA E AMA O
                  </span>
                  <br />
                  DINHEIRO CAMPEÃO
                </h1>
              </div>
              <div className="sec7content-sec2-cards-con">
                <div className="sec7content-sec2-card">
                  <div className="sec7content-sec2-card-sec1">
                    <img src={sec7cardimg1} />
                  </div>
                  <div className="sec7content-sec2-card-sec2">
                    <div className="card-name-username">
                      <h1>AUGUSTO CURRY</h1>
                      <p>@aug_curry</p>
                    </div>
                    <div className="card-text">
                      <p>
                        Muito bom. Encontro tudo que quero e ainda ganho
                        dinheiro!! Recomendo!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="sec7content-sec2-card">
                  <div className="sec7content-sec2-card-sec1">
                    <img src={sec7cardimg1} />
                  </div>
                  <div className="sec7content-sec2-card-sec2">
                    <div className="card-name-username">
                      <h1>AUGUSTO CURRY</h1>
                      <p>@aug_curry</p>
                    </div>
                    <div className="card-text">
                      <p>
                        Muito bom. Encontro tudo que quero e ainda ganho
                        dinheiro!! Recomendo!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="sec7content-sec2-card">
                  <div className="sec7content-sec2-card-sec1">
                    <img src={sec7cardimg1} />
                  </div>
                  <div className="sec7content-sec2-card-sec2">
                    <div className="card-name-username">
                      <h1>AUGUSTO CURRY</h1>
                      <p>@aug_curry</p>
                    </div>
                    <div className="card-text">
                      <p>
                        Muito bom. Encontro tudo que quero e ainda ganho
                        dinheiro!! Recomendo!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="sec7content-sec2-card">
                  <div className="sec7content-sec2-card-sec1">
                    <img src={sec7cardimg1} />
                  </div>
                  <div className="sec7content-sec2-card-sec2">
                    <div className="card-name-username">
                      <h1>AUGUSTO CURRY</h1>
                      <p>@aug_curry</p>
                    </div>
                    <div className="card-text">
                      <p>
                        Muito bom. Encontro tudo que quero e ainda ganho
                        dinheiro!! Recomendo!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="sec7content-sec3-con">
                <div className="sec7content-sec3-text">
                  <p>
                    Faça parte de nossa rede de campeãs e campeãos! Realize seu
                    cadastro!
                  </p>
                </div>
                <div className="sec7content-sec3-btn">
                  <button onClick={handleOpen}>
                    Quero fazer parte do time campeão!
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sec7content-mobile-con">
          <div className="sec7-content-mobile-heading">
            <div className="sec7content-sec-heading">
              <h1>
                <span style={{ fontSize: "5vw", color: "#421072" }}>
                  QUEM USA E AMA O
                </span>
                <br />
                DINHEIRO CAMPEÃO
              </h1>
            </div>
          </div>
          <div className="sec7-content-mobile-img">
            <img src={sec7img} />
          </div>
          <div className="sec7-content-mobile-cards-con">
            <div className="sec7-content-mobile-cards">
              <div className="sec7content-sec2-card">
                <div className="sec7content-sec2-card-sec1">
                  <img src={sec7cardimg1} />
                </div>
                <div className="sec7content-sec2-card-sec2">
                  <div className="card-name-username">
                    <h1>AUGUSTO CURRY</h1>
                    <p>@aug_curry</p>
                  </div>
                  <div className="card-text">
                    <p>
                      Muito bom. Encontro tudo que quero e ainda ganho
                      dinheiro!! Recomendo!
                    </p>
                  </div>
                </div>
              </div>
              <div className="sec7content-sec2-card">
                <div className="sec7content-sec2-card-sec1">
                  <img src={sec7cardimg1} />
                </div>
                <div className="sec7content-sec2-card-sec2">
                  <div className="card-name-username">
                    <h1>AUGUSTO CURRY</h1>
                    <p>@aug_curry</p>
                  </div>
                  <div className="card-text">
                    <p>
                      Muito bom. Encontro tudo que quero e ainda ganho
                      dinheiro!! Recomendo!
                    </p>
                  </div>
                </div>
              </div>
              <div className="sec7content-sec2-card">
                <div className="sec7content-sec2-card-sec1">
                  <img src={sec7cardimg1} />
                </div>
                <div className="sec7content-sec2-card-sec2">
                  <div className="card-name-username">
                    <h1>AUGUSTO CURRY</h1>
                    <p>@aug_curry</p>
                  </div>
                  <div className="card-text">
                    <p>
                      Muito bom. Encontro tudo que quero e ainda ganho
                      dinheiro!! Recomendo!
                    </p>
                  </div>
                </div>
              </div>
              <div className="sec7content-sec2-card">
                <div className="sec7content-sec2-card-sec1">
                  <img src={sec7cardimg1} />
                </div>
                <div className="sec7content-sec2-card-sec2">
                  <div className="card-name-username">
                    <h1>AUGUSTO CURRY</h1>
                    <p>@aug_curry</p>
                  </div>
                  <div className="card-text">
                    <p>
                      Muito bom. Encontro tudo que quero e ainda ganho
                      dinheiro!! Recomendo!
                    </p>
                  </div>
                </div>
              </div>
              <div className="sec7content-sec3-con">
                <div className="sec7content-sec3-text">
                  <p>
                    Faça parte de nossa rede de campeãs e campeãos! Realize seu
                    cadastro!
                  </p>
                </div>
                <div className="sec7content-sec3-btn">
                  <button onClick={handleOpen}>
                    Quero fazer parte do time campeão!
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const Sec8Content = () => {
    return (
      <div className="sec8content-con">
        <div className="sec8content">
          <div className="sec8content-sec1-con">
            <div className="sec8content-sec1">
              <img src={sec8img1} />
              <div className="sec8content-sec1-text">
                <h1>10.000</h1>
                <p>USUÁRIOS</p>
              </div>
            </div>
            <div className="sec8content-sec1">
              <img src={sec8img2} />
              <div className="sec8content-sec1-text">
                <h1>300</h1>
                <p>LOJAS VIRTUAIS</p>
              </div>
            </div>
            <div className="sec8content-sec1">
              <img src={sec8img3} />
              <div className="sec8content-sec1-text">
                <h1>1.000</h1>
                <p>LOJAS FÍSICAS</p>
              </div>
            </div>
            <div className="sec8content-sec1">
              <img src={sec8img4} />
              <div className="sec8content-sec1-text">
                <h1>600</h1>
                <p>CIDADES</p>
              </div>
            </div>
          </div>
          <div className="sec8content-sec2">
            <img src={sec8line} />
          </div>
          <div className="sec8content-sec3">
            <h1>R$ 10.000.000,00</h1>
            <p>de DINHEIRO DE VOLTA gerado e devolvido aos nossos usuários</p>
          </div>
        </div>
      </div>
    );
  };
  const Sec9Content = () => {
    return (
      <div className="sec9content-con">
        <div className="sec9content">
          <div className="sec9-sec1">
            <img src={sec9img} />
          </div>
          <div className="sec9-sec2-con">
            <div className="sec9-sec2">
              <div className="sec9-sec2-text">
                <h1 className="sec9-sec2-text-heading1">PARCEIRO</h1>
                <h1 className="sec9-sec2-text-heading2">OFICIAL</h1>
                <p>
                  Faça igual ao Corinthians e faça parte deste time de grandes
                  campeões!
                </p>
              </div>
              <div className="sec9-sec2-btn">
                <button>Quero fazer parte!</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const Sec10Content = () => {
    return (
      <div className="sec10content-con">
        <div className="sec10content-heading">
          <h1>PERGUNTAS FREQUENTES</h1>
        </div>
        <div className="sec10content-sec2-con">
          <div className="sec10content-sec2">
            <Accordion className="accordian">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className="accordian-text">
                  1. Aqui vai uma pergunta em comum de usuários
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className="accordian-details">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="sec10content-sec2">
            <Accordion className="accordian">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className="accordian-text">
                  2. Aqui vai uma pergunta em comum de usuários
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className="accordian-details">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="sec10content-sec2">
            <Accordion className="accordian">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className="accordian-text">
                  3. Aqui vai uma pergunta em comum de usuários
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className="accordian-details">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="sec10content-sec2">
            <Accordion className="accordian">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className="accordian-text">
                  4. Aqui vai uma pergunta em comum de usuários
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className="accordian-details">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="sec10content-sec2">
            <Accordion className="accordian">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className="accordian-text">
                  5. Aqui vai uma pergunta em comum de usuários
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className="accordian-details">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="sec10content-sec2">
            <Accordion className="accordian">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className="accordian-text">
                  6. Aqui vai uma pergunta em comum de usuários
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className="accordian-details">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="sec10content-sec2">
            <Accordion className="accordian">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className="accordian-text">
                  7. Aqui vai uma pergunta em comum de usuários
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className="accordian-details">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
    );
  };
  const Sec11Content = () => {
    return (
      <div className="sec11content-con">
        <div className="sec11content">
          <div className="sec11content-sec1">
            <h1>O que está esperando?</h1>
            <button onClick={handleOpen}>
              Quero fazer parte deste time de campeões e receber dinheiro de
              volta!
            </button>
          </div>
        </div>
      </div>
    );
  };
  const Footer = () => {
    return (
      <div className="footer-con">
        <div className="footer-secs">
          <div className="footer-sec1">
            <img src={footerlogo} />
          </div>
          <div className="footer-sec2">
            <img src={locationicon} />
            <p>
              Av. Copacabana, 325 Sala 2001 - Alphaville Barueri/SP • CEP
              06.472-001
            </p>
          </div>
          <div className="footer-sec2">
            <img style={{ width: "1.9vw" }} src={emailicon} />
            <p>
              Entre em contato conosco. Estamos aqui para atende-lo o mais breve
              possível.
            </p>
          </div>
          <div className="footersec3">
            <div className="footer-sec3-social-links">
              <button>
                <span>
                  <img
                    style={{ width: "0.8vw", height: "1.1vw" }}
                    src={fbicon}
                  />
                </span>
              </button>
              <button>
                <span>
                  <img
                    style={{ width: "1.2vw", height: "1.1vw" }}
                    src={instaicon}
                  />
                </span>
              </button>
              <button>
                <span>
                  <img
                    style={{ width: "1.3vw", height: "0.9vw" }}
                    src={linkedinicon}
                  />
                </span>
              </button>
              <button>
                <span>
                  <img
                    style={{ width: "1vw", height: "0.9vw" }}
                    src={twittericon}
                  />
                </span>
              </button>
            </div>
            <div className="footersec3-text">
              <p>Termo de Uso • Política de Privacidade</p>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="landingpage-con">
      <div className="landingpage-sec1">
        <Header />
        <Sec1Content />
      </div>
      <Sec2Content />
      <Sec3Content />
      <div className="sec4-content-desktop">
        <Sec4Content
          firstheading="VOCE FAZ O"
          secondheading="BEM..."
          text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas facilisis erat nec mollis mattis. Fusce sed bibendum lorem. Integer vel lectus odio. Morbi sed tellus velit. Integer ligula quam, sagittis nec urna at, egestas aliquam lectus. Phasellus ac lacus in massa consequat eleifend vitae id enim. Morbi rhoncus eu mauris id facilisis. Integer et blandit magna, non suscipit metus. Praesent pellentesque scelerisque lectus ut iaculis. Mauris malesuada ut mauris nec ultricies. Ut nec tempus ligula. Mauris luctus lacinia quam, vel tempus ipsum efficitur quis. Ut sit amet maximus arcu, sit amet consectetur justo. Quisque consectetur iaculis leo vel efficitur."
          btntext="Efetue seu cadastro!"
          img={sec4contentimg1}
          sec4contentsec1alignment1="flex"
          sec4contentsec1alignment2="flex-start"
          sec4contentsec1alignment3="column"
          sec4contentalignment1="flex"
          sec4contentalignment2="center"
          sec4contentalignment3="space-around"
          sec4contentalignment4="row"
          sec4contentaligment5="start"
        />
        <Sec4Content
          firstheading="...AJUDA SEU TIME DO"
          secondheading="CORAÇÃO"
          text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas facilisis erat nec mollis mattis. Fusce sed bibendum lorem. Integer vel lectus odio. Morbi sed tellus velit. Integer ligula quam, sagittis nec urna at, egestas aliquam lectus. Phasellus ac lacus in massa consequat eleifend vitae id enim. Morbi rhoncus eu mauris id facilisis. Integer et blandit magna, non suscipit metus. Praesent pellentesque scelerisque lectus ut iaculis. Mauris malesuada ut mauris nec ultricies. Ut nec tempus ligula. Mauris luctus lacinia quam, vel tempus ipsum efficitur quis. Ut sit amet maximus arcu, sit amet consectetur justo. Quisque consectetur iaculis leo vel efficitur."
          btntext="Efetue seu cadastro!"
          img={sec4contentimg2}
          sec4contentsec1alignment1="flex"
          sec4contentsec1alignment2="flex-end"
          sec4contentsec1alignment3="column"
          sec4contentalignment1="flex"
          sec4contentalignment2="center"
          sec4contentalignment3="space-around"
          sec4contentalignment4="row-reverse"
          sec4contentaligment5="end"
        />
        <Sec4Content
          firstheading="...E AINDA CONCORRE A"
          secondheading="PRÊMIOS!"
          text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas facilisis erat nec mollis mattis. Fusce sed bibendum lorem. Integer vel lectus odio. Morbi sed tellus velit. Integer ligula quam, sagittis nec urna at, egestas aliquam lectus. Phasellus ac lacus in massa consequat eleifend vitae id enim. Morbi rhoncus eu mauris id facilisis. Integer et blandit magna, non suscipit metus. Praesent pellentesque scelerisque lectus ut iaculis. Mauris malesuada ut mauris nec ultricies. Ut nec tempus ligula. Mauris luctus lacinia quam, vel tempus ipsum efficitur quis. Ut sit amet maximus arcu, sit amet consectetur justo. Quisque consectetur iaculis leo vel efficitur."
          btntext="Efetue seu cadastro!"
          img={sec4contentimg3}
          sec4contentsec1alignment1="flex"
          sec4contentsec1alignment2="flex-start"
          sec4contentsec1alignment3="column"
          sec4contentalignment1="flex"
          sec4contentalignment2="center"
          sec4contentalignment3="space-around"
          sec4contentalignment4="row"
          sec4contentaligment5="start"
        />
      </div>
      <Sec5Content />
      <Sec6Content />
      <Sec7Content />
      <Sec8Content />
      <Sec9Content />
      <Sec10Content />
      <Sec11Content />
      <Footer />
      <div
        className="modal"
        style={{
          display: open === false ? 'none' : null
        }}
      >
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="modal" sx={style}>
            <div className="modalcontent-con">
              <div className="modalsec1"></div>
              <div className="modalsec2">
                <button onClick={handleClose}>
                  <span>
                    <img src={closeicon} />
                  </span>
                </button>
              </div>
              <div className="modal-sec3">
                <p>
                  Cadastre-se e comece a receber dinheiro de volta em suas
                  compras!{" "}
                  <span style={{ fontWeight: "bolder" }}>
                    É fácil, rápido e seguro!
                  </span>{" "}
                </p>
              </div>
              <div className="modal-sec4">
                <input type="text" placeholder="Digite seu nome" />
                <input type="number" placeholder="DDD + Telefone" />
              </div>
              <div className="modal-sec5">
                <button>Cadastrar</button>
              </div>
            </div>
          </Box>
        </Modal>
      </div>
    </div>
  );
}
export default LandingPage;
